import { getContentTestingFromPath } from '../content-testing/routes';
import { getLegalFromPath, normalizePath } from '../legal/routes';

export type Language = 'en' | 'de';

/** Language encoded in the path. `/` is English and `/de` is German. */
export function languageFromPath(pathname: string): Language | null {
  const path = normalizePath(pathname);
  if (path === '/') return 'en';
  if (path === '/de') return 'de';

  const legal = getLegalFromPath(pathname);
  if (legal) return legal.language;

  const scan = getContentTestingFromPath(pathname);
  if (scan) return scan.language;

  return null;
}

export function isHomePath(pathname: string): boolean {
  const path = normalizePath(pathname);
  return path === '/' || path === '/de';
}

export function homePathFor(language: Language): string {
  return language === 'de' ? '/de' : '/';
}
